import { routes as dashboard } from './dashboard'
import { routes as contracts } from './contracts'
import { routes as singleorder } from './singleorder'
import { routes as auth } from './auth'
import { routes as admin } from './admin'

// ...dashboard must be the last one because of the catchall instruction
export default [
  ...auth,
  ...singleorder,
  ...contracts,
  ...dashboard,
  ...admin,
]



// WEBPACK FOOTER //
// ./src/app/routes.js